module.exports = __webpack_public_path__ + "img/link-7.42580910.png";